import React from 'react';
import Logo from './Logo';
import Nav from './Nav';

const DesktopHeaderContent = ({ content }) => {
  return (
    <div className="container">
      <div className="desktop-header-content-wrapper">
        <div className="desktop-header-left">
          <Logo image="/images/nav_footer/Atlantic_labs_long.svg" />
          <Nav content={content.nav} />
        </div>
        <div className="desktop-header-right"></div>
      </div>
    </div>
  );
};

export default DesktopHeaderContent;

// CSS Structure
/* 
  .desktop.header-content-wrapper {
    .desktop-header-left {
      .logo {
        .logo-img {
        }
      }
      .main-menu-nav {
        .main-menu-nav-list {
          .main-menu-list-item {
            .main-menu-link {
            }
            &.has-dropdown {
              .main-menu-link {
              }
            }
          }
        }
        .submenu-wrapper {
          .container {
            .submenu-title-group {
              .submenu-title {
              }
            }
            .submenu-list {
              .submenu-item {
                .submenu-link {
                }
                &.btn-wrapper {
                  &.btn-default {
                  }
                }
              }
            }
            .contact-us-wrapper {
              .contact-us-link {
                .contact-us-content {
                  .assist-text {
                  }
                  .phone-img-wrapper {
                  }
                  .phone-icon-img {
                  }
                  .contact-us-rep-img {
                  }
                }
                .contact-us-img-bg {
                }
              }
            }
          }
        }
      }
    }
    .desktop-header-right {
    }
  }
*/
